/**
 * Utility for checking MTG card format legality against Scryfall legality data.
 */

export interface CardLegalityResult {
  isLegal: boolean;
  status: 'legal' | 'not_legal' | 'banned' | 'restricted' | 'unknown';
  formattedStatus: string;
}

export function checkCardLegality(
  legalities?: Record<string, string>,
  formatName: string = 'standard'
): CardLegalityResult {
  if (!legalities || Object.keys(legalities).length === 0) {
    return {
      isLegal: true,
      status: 'unknown',
      formattedStatus: 'Legality Unknown',
    };
  }

  const normalized = (formatName || 'standard').toLowerCase();
  
  let key = normalized;
  if (normalized === 'auto') key = 'standard';
  if (normalized === 'edh' || normalized === 'commander') key = 'commander';

  const statusVal = legalities[key] || 'not_legal';
  const isLegal = statusVal === 'legal' || statusVal === 'restricted';

  const displayFormat = key.charAt(0).toUpperCase() + key.slice(1);

  let formattedStatus = `Illegal in ${displayFormat}`;
  if (statusVal === 'banned') {
    formattedStatus = `Banned in ${displayFormat}`;
  } else if (statusVal === 'restricted') {
    formattedStatus = `Restricted in ${displayFormat}`;
  } else if (statusVal === 'legal') {
    formattedStatus = `Legal in ${displayFormat}`;
  }

  return {
    isLegal,
    status: statusVal as CardLegalityResult['status'],
    formattedStatus,
  };
}
